import create from "zustand";
import spuServices from "../services/spu";

interface SpuPdfParam {
  modules: {
    key: string;
    name: string;
    checked: boolean;
  }[];
  paperSize: "A0" | "A1" | "A2" | "A3" | "A4" | "A3" | "A5";
  margin: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  company: {
    name: string;
    founder: string;
    phone: string;
    email: string;
    date: string;
  };
  filename: string;
  images: {
    performance: string;
    performanceSpeed: string;
    multiSpeed: string;
    seriesParallel: string;
  };
  type: number,
  tempList: {
    key: number,
    value: string
  }[],
  parameters: {
    spu_name: string;
    Q: string;
    H: string;
    temperature: string;
    NPSHr: string;
    EFF: string;
  };
  motor: {
    information: string;
    value: string;
  };
  loading: boolean;
}

interface SpuPdfParamState extends SpuPdfParam {
  fetch: (id: string) => void;
  reset: () => void;
  setType: (val: number) => void;
  setPerformanceImage: (image: string) => void;
  setPerformanceSpeedImage: (image: string) => void;
  setMultiSpeedImage: (image: string) => void;
  setSeriesParallel: (image: string) => void;
}

const parsePdfParameter = (data: any) => {
  const { lang, page_set, company_head } = data;
  const { model_view, spu, export_template } = lang;
  initialState.parameters.spu_name = spu
  return {
    modules: model_view.map((item: any) => ({
      key: item.key,
      name: item.desc,
      checked: true,
    })),
    tempList: export_template,
    paperSize: page_set.format,
    margin: {
      top: page_set.margin_top,
      right: page_set.margin_right,
      bottom: page_set.margin_bottom,
      left: page_set.margin_left,
    },
    type: export_template && export_template.length?export_template[0].key:1,
    company: {
      name: company_head.name,
      founder: company_head.founder,
      email: company_head.email,
      phone: company_head.mobile,
      date: company_head.date,
    },
    filename: spu,
  };
};

const initialState: SpuPdfParam = {
  modules: [],
  paperSize: "A0",
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  company: {
    name: "",
    founder: "",
    phone: "",
    email: "",
    date: "",
  },
  filename: "",
  images: {
    performance: "",
    performanceSpeed: "",
    multiSpeed: "",
    seriesParallel: "",
  },
  type: 1,
  tempList: [],
  parameters: {
    spu_name: "",
    Q: "",
    H: "",
    temperature: "",
    NPSHr: "",
    EFF: "",
  },
  motor: {
    information: "",
    value: "",
  },
  loading: false,
};

const useSpuPdfParam = create<SpuPdfParamState>((set, get) => ({
  ...initialState,
  fetch: async (id: string) => {
    try {
      set({ loading: true });

      const images = get().images;
      set({ ...initialState, images });


      const res = await spuServices.getPdfParameter(id);
      const data = res.data.response;

      const newPdfParameter = parsePdfParameter(data);

      const now = get();

      set({ ...now, ...newPdfParameter });
    } catch (e) {
      console.error(e);
      set({ ...initialState });
    } finally {
      set({ loading: false });
    }
  },
  setType: (val: number) => set({type: val}),
  reset: () => {
    set({ ...initialState });
  },
  setPerformanceImage: (image: string) => {
    set(({ images }) => ({ images: { ...images, performance: image } }))
  },
  setPerformanceSpeedImage: (image: string) =>
    set(({ images }) => ({ images: { ...images, performanceSpeed: image } })),
  setMultiSpeedImage: (image: string) =>
    set(({ images }) => ({ images: { ...images, multiSpeed: image } })),
  setSeriesParallel: (image: string) =>
    set(({ images }) => ({ images: { ...images, seriesParallel: image } }))
}));

export default useSpuPdfParam;
